import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { AlertTriangle, FileText, BellRing, Link2, X } from "lucide-react";

export const QrModal = ({ onClose, onCopied }) => (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={onClose} data-testid="qr-modal">
          <div className="bg-white rounded-2xl p-7 max-w-sm w-full text-center relative" onClick={(e) => e.stopPropagation()}>
            <button onClick={onClose} className="absolute top-4 right-4 text-neutral-400 hover:text-neutral-700"><X size={20} /></button>
            <h3 className="font-heading font-bold text-lg text-neutral-900 mb-1">Accès app intervenant</h3>
            <p className="text-sm text-neutral-500 mb-4">Vos collaborateurs scannent ce code pour ouvrir l'application de pointage sur leur téléphone.</p>
            <div className="flex justify-center bg-white p-4 rounded-xl border border-neutral-200">
              <QRCodeSVG value={`${window.location.origin}/app`} size={200} fgColor="#111111" level="M" />
            </div>
            <p className="text-xs text-neutral-500 mt-4 break-all">{window.location.origin}/app</p>
            <button onClick={() => { navigator.clipboard.writeText(`${window.location.origin}/app`); onCopied(); }}
              className="mt-3 text-sm text-brand hover:underline flex items-center gap-1.5 mx-auto"><Link2 size={14} /> Copier le lien</button>
          </div>
        </div>
);

export const InterventionSettings = ({ radius, autoSend, reminders, changeRadius, changeAutoSend, changeReminders }) => (
  <>
      <div className="bg-white border border-neutral-200 rounded-xl p-4 mb-5 flex flex-wrap items-center gap-3" data-testid="gps-radius-setting">
        <AlertTriangle size={16} className="text-amber-500" />
        <span className="text-sm text-neutral-700">Alerter l'admin si un pointage a lieu au-delà de</span>
        <select value={radius} onChange={(e) => changeRadius(e.target.value)} data-testid="gps-radius-select"
          className="border border-neutral-300 rounded-md px-3 py-1.5 text-sm font-semibold focus:outline-none focus:border-brand">
          <option value={300}>300 m</option>
          <option value={500}>500 m</option>
          <option value={1000}>1 km</option>
        </select>
        <span className="text-sm text-neutral-500">de l'adresse prévue du client.</span>
      </div>

      <div className="bg-white border border-neutral-200 rounded-xl p-4 mb-5 flex flex-wrap items-center gap-3" data-testid="report-autosend-setting">
        <FileText size={16} className="text-brand" />
        <span className="text-sm text-neutral-700">Rapport PDF (photos avant/après, horodatage, signature)</span>
        <label className="ml-auto flex items-center gap-2 text-sm text-neutral-700 cursor-pointer">
          <input type="checkbox" checked={autoSend} onChange={(e) => changeAutoSend(e.target.checked)} className="accent-brand w-4 h-4" data-testid="report-autosend-checkbox" />
          Envoyer automatiquement au client en fin de prestation
        </label>
      </div>

      <div className="bg-white border border-neutral-200 rounded-xl p-4 mb-5 flex flex-wrap items-center gap-3" data-testid="reminders-setting">
        <BellRing size={16} className="text-brand" />
        <span className="text-sm text-neutral-700">Rappel de planning par email aux collaborateurs, la veille à</span>
        <select value={reminders.hour} onChange={(e) => changeReminders({ ...reminders, hour: parseInt(e.target.value, 10) })} data-testid="reminders-hour-select"
          className="border border-neutral-300 rounded-md px-2 py-1.5 text-sm font-semibold focus:outline-none focus:border-brand">
          {Array.from({ length: 24 }, (_, h) => <option key={h} value={h}>{`${String(h).padStart(2, "0")}h`}</option>)}
        </select>
        <label className="ml-auto flex items-center gap-2 text-sm text-neutral-700 cursor-pointer">
          <input type="checkbox" checked={reminders.enabled} onChange={(e) => changeReminders({ ...reminders, enabled: e.target.checked })} className="accent-brand w-4 h-4" data-testid="reminders-enabled-checkbox" />
          Activer
        </label>
      </div>
  </>
);
